'use strict';

export default class MediaActions {
    constructor() {
        this.generateActions(
            'loadMediaSuccess',
            'loadMediaModalsSuccess',
            'loadMediaError',
            'loadLandingPageSuccess',
            'loadLandingPageError',
            'checkQuotaSuccess',
            'checkQuotaError',
            'toggleItemSelection',
            'toggleFilter',
            'updateFilterParams',
            'toggleExpand',
            'toggleBasket',
            'toggleAllItemSelection',
            'removeAllItemSelection',
            'toggleItemAddedNotification',
            'clearSearch',
            'clearQuery',
            'closeFilters',
            'closeBasket',
            'removeSelectedFilter',
            'setNextElement',
            'setPreviousElement',
            'openCurrentMedia',
            'fetchPreviousPage',
            'fetchNextPage',
            'cloneMediaAndMetaToModalData',
            'cloneMediaAndMetaToModalDataFromBasket',
            'cloneMediaAndMetaToModalDataFromShared',
            'cloneSlotDefinitionsToModalDataFromBasket',
            'cloneSlotDefinitionsToModalDataFromShared',
            'setLayout'
        );
    }
}



// WEBPACK FOOTER //
// ./app/actions/mediaActions.js